// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================= */
/* General & Container Styling */
/* ========================= */
.manage-order-container {
    /* Define variables locally within this component's scope */
    --primary-color: #1a82e8;
    --text-color-light: #ffffff;
    --text-color-dark: #333333;
    --background-color-light: #ffffff;
    --shadow-color: rgba(0, 0, 0, 0.05);
    --success-color: #28a745;
    --pending-color: #f0ad4e;
    --danger-color: #dc3545; /* Defined the Expired color here */
    
    margin: 30px auto;
    padding: 20px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.separator {
    border: 0;
    height: 1px;
    background: #ccc;
    margin: 40px 0;
}

/* ========================= */
/* Single Code Search & Popup */
/* ========================= */
.search-form {
    margin: 2% 20% 5% 20%;
    display: flex;
    gap: 10px;
}

.search-form .search-button {
    
}

.search-form input {
    flex: 1 1;
    padding: 10px 14px;
    border-radius: 8px;
    border: 1px solid #ccc;
    font-size: 1rem;
}

.search-form button {
    padding: 10px 18px;
    background-color: var(--primary-color);
    color: var(--text-color-light);
    border: none;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease;
}

.search-form button:hover {
    background-color: #147ad6;
}

.search-form button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.message {
    margin: 10px 0;
    color: var(--text-color-dark);
    font-weight: 500;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(20, 20, 20, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    backdrop-filter: blur(4px);
}

.modal-card {
    background: var(--background-color-light);
    border-radius: 16px;
    padding: 20px 25px;
    max-width: 500px;
    box-shadow:
        0 4px 15px var(--shadow-color),
        0 8px 25px var(--shadow-color);
    animation: fadeIn 0.3s ease-in-out;
    position: relative;
    transition: transform 0.2s, box-shadow 0.2s;
    border: 1px solid #f0f0f0;
}

.modal-card h3 {
    text-align: center;
    font-size: 1.6rem;
    color: var(--text-color-dark);
    font-weight: 700;
    margin-bottom: 20px;
}

.modal-card:hover {
    transform: translateY(-2px) scale(1.005);
    box-shadow:
        0 6px 20px rgba(0, 0, 0, 0.1),
        0 10px 30px rgba(0, 0, 0, 0.1);
}

.modal-card pre {
    background: #f8f9fa;
    color: var(--text-color-dark);
    padding: 15px;
    border-radius: 10px;
    overflow-x: auto;
    font-size: 0.9rem;
    max-height: 250px;
    margin: 10px 0;
}

.code-detail {
    color: #555;
    line-height: 1.6;
}

.code-detail p {
    margin: 10px 0;
}

.code-detail strong {
    font-weight: 600;
    color: #222;
}

.action-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    gap: 12px;
}

.action-buttons button {
    flex: 1 1;
    padding: 12px;
    border: none;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease, transform 0.1s ease;
}

.action-buttons button:hover {
    opacity: 0.9;
    transform: translateY(-2px);
}

.action-buttons button:nth-child(1) {
    background: #ff4d4f;
    color: var(--text-color-light);
}

.action-buttons button:nth-child(2) {
    background: var(--primary-color);
    color: var(--text-color-light);
}

.close-btn {
    background: #ccc;
    color: var(--text-color-dark);
}

.close-btn:hover {
    background: #aaa;
    color: var(--text-color-light);
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px) scale(0.95);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* ========================= */
/* REVISED: User Codes Cards Layout */
/* ========================= */
.user-codes-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 25px;
    margin: 25px;
}

.manage-code-card {
    background: var(--background-color-light);
    color: var(--text-color-dark);
    padding: 25px;
    border-radius: 12px;
    box-shadow:
        0 4px 15px var(--shadow-color),
        0 8px 25px var(--shadow-color);
    cursor: pointer;
    min-height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    word-wrap: break-word;
    overflow: hidden;
    transition: transform 0.2s, box-shadow 0.2s, border 0.2s;
    border: 1px solid #f0f0f0;
    background-color: white;
}

.manage-code-card:hover {
    transform: translateY(-5px) scale(1.02);
    box-shadow:
        0 6px 20px rgba(0, 0, 0, 0.1),
        0 12px 30px rgba(0, 0, 0, 0.15);
}

/* NEW: This class will align the product name and status badge side-by-side. */
.product-header {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px; /* Adjust the spacing between the name and status */
    margin: 5px;
}

.manage-code-card h3 {
    color: var(--primary-color);
    margin-top: 0;
    margin-bottom: 5px;
    font-size: 1.25em;
    font-weight: 700;
    word-break: break-all;
}

.manage-code-card p {
    color: #666;
    font-size: 1em;
    font-weight: 400;
    margin: 5px 0;
    word-break: break-all;
}

.test {
    font-weight: 500;
    margin: 5px 0px;
}

/* REVISED: Styles for the status badge */
.manage-code-card .status {
    padding: 0.3rem 0.8rem;
    border-radius: 20px;
    font-size: 0.85rem;
    font-weight: 600;
    text-transform: capitalize;
    color: var(--text-color-light);
    margin: 0;
}

.manage-code-card .status.used {
    background-color: var(--success-color);
    box-shadow: 0 0 8px #28a745; 
}

.manage-code-card .status.unused {
    background-color: var(--pending-color);
    box-shadow: 0 0 8px #f0ad4e; 
}

/* 🌟 NEW ADDITION FOR EXPIRED STATUS 🌟 */
.manage-code-card .status.expired {
    /* Uses the locally defined --danger-color */
    background-color: var(--danger-color); 
    box-shadow: 0 0 8px #dc3545; 
}
/* ------------------------------------- */


@media (max-width: 768px) {
    .search-form {
        margin: 2% 10% 7% 10%;
        display: flex;
        gap: 10px;
    }
    
    .manage-code-card .status {
        padding: 2px 6px;
        margin: 0;
        font-size: 13px;
    }

    .manage-order-container {
        margin:0;
        padding: 0;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }

    .manage-code-card p {
        font-size: 15px;
    }

    .manage-code-card h3 {
        font-size: 17px;
    }

    .manage-code-card {
        padding: 10px;
        min-height: 100px;
    }

    .user-codes-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
        margin: 1%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/ManageCode.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B,gCAAgC;AAChC,8BAA8B;AAC9B;IACI,2DAA2D;IAC3D,wBAAwB;IACxB,2BAA2B;IAC3B,0BAA0B;IAC1B,iCAAiC;IACjC,mCAAmC;IACnC,wBAAwB;IACxB,wBAAwB;IACxB,uBAAuB,EAAE,mCAAmC;;IAE5D,iBAAiB;IACjB,aAAa;IACb,4DAA4D;AAChE;;AAEA;IACI,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA,8BAA8B;AAC9B,+BAA+B;AAC/B,8BAA8B;AAC9B;IACI,qBAAqB;IACrB,aAAa;IACb,SAAS;AACb;;AAEA;;AAEA;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB;;sCAEkC;IAClC,kCAAkC;IAClC,kBAAkB;IAClB,2CAA2C;IAC3C,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC;;sCAEkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,qDAAqD;AACzD;;AAEA;IACI,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;IACA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA,8BAA8B;AAC9B,qCAAqC;AACrC,8BAA8B;AAC9B;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,yCAAyC;IACzC,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB;;sCAEkC;IAClC,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,wDAAwD;IACxD,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,uCAAuC;IACvC;;uCAEmC;AACvC;;AAEA,+EAA+E;AAC/E;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS,EAAE,mDAAmD;IAC9D,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA,yCAAyC;AACzC;IACI,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA,0CAA0C;AAC1C;IACI,4CAA4C;IAC5C,qCAAqC;IACrC,2BAA2B;AAC/B;AACA,0CAA0C;;;AAG1C;IACI;QACI,qBAAqB;QACrB,aAAa;QACb,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,UAAU;QACV,4DAA4D;IAChE;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,qCAAqC;QACrC,SAAS;QACT,UAAU;IACd;AACJ","sourcesContent":["/* ========================= */\n/* General & Container Styling */\n/* ========================= */\n.manage-order-container {\n    /* Define variables locally within this component's scope */\n    --primary-color: #1a82e8;\n    --text-color-light: #ffffff;\n    --text-color-dark: #333333;\n    --background-color-light: #ffffff;\n    --shadow-color: rgba(0, 0, 0, 0.05);\n    --success-color: #28a745;\n    --pending-color: #f0ad4e;\n    --danger-color: #dc3545; /* Defined the Expired color here */\n    \n    margin: 30px auto;\n    padding: 20px;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.separator {\n    border: 0;\n    height: 1px;\n    background: #ccc;\n    margin: 40px 0;\n}\n\n/* ========================= */\n/* Single Code Search & Popup */\n/* ========================= */\n.search-form {\n    margin: 2% 20% 5% 20%;\n    display: flex;\n    gap: 10px;\n}\n\n.search-form .search-button {\n    \n}\n\n.search-form input {\n    flex: 1;\n    padding: 10px 14px;\n    border-radius: 8px;\n    border: 1px solid #ccc;\n    font-size: 1rem;\n}\n\n.search-form button {\n    padding: 10px 18px;\n    background-color: var(--primary-color);\n    color: var(--text-color-light);\n    border: none;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.2s ease;\n}\n\n.search-form button:hover {\n    background-color: #147ad6;\n}\n\n.search-form button:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}\n\n.message {\n    margin: 10px 0;\n    color: var(--text-color-dark);\n    font-weight: 500;\n}\n\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(20, 20, 20, 0.6);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    backdrop-filter: blur(4px);\n}\n\n.modal-card {\n    background: var(--background-color-light);\n    border-radius: 16px;\n    padding: 20px 25px;\n    max-width: 500px;\n    box-shadow:\n        0 4px 15px var(--shadow-color),\n        0 8px 25px var(--shadow-color);\n    animation: fadeIn 0.3s ease-in-out;\n    position: relative;\n    transition: transform 0.2s, box-shadow 0.2s;\n    border: 1px solid #f0f0f0;\n}\n\n.modal-card h3 {\n    text-align: center;\n    font-size: 1.6rem;\n    color: var(--text-color-dark);\n    font-weight: 700;\n    margin-bottom: 20px;\n}\n\n.modal-card:hover {\n    transform: translateY(-2px) scale(1.005);\n    box-shadow:\n        0 6px 20px rgba(0, 0, 0, 0.1),\n        0 10px 30px rgba(0, 0, 0, 0.1);\n}\n\n.modal-card pre {\n    background: #f8f9fa;\n    color: var(--text-color-dark);\n    padding: 15px;\n    border-radius: 10px;\n    overflow-x: auto;\n    font-size: 0.9rem;\n    max-height: 250px;\n    margin: 10px 0;\n}\n\n.code-detail {\n    color: #555;\n    line-height: 1.6;\n}\n\n.code-detail p {\n    margin: 10px 0;\n}\n\n.code-detail strong {\n    font-weight: 600;\n    color: #222;\n}\n\n.action-buttons {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 40px;\n    gap: 12px;\n}\n\n.action-buttons button {\n    flex: 1;\n    padding: 12px;\n    border: none;\n    border-radius: 10px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.2s ease, transform 0.1s ease;\n}\n\n.action-buttons button:hover {\n    opacity: 0.9;\n    transform: translateY(-2px);\n}\n\n.action-buttons button:nth-child(1) {\n    background: #ff4d4f;\n    color: var(--text-color-light);\n}\n\n.action-buttons button:nth-child(2) {\n    background: var(--primary-color);\n    color: var(--text-color-light);\n}\n\n.close-btn {\n    background: #ccc;\n    color: var(--text-color-dark);\n}\n\n.close-btn:hover {\n    background: #aaa;\n    color: var(--text-color-light);\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(20px) scale(0.95);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n/* ========================= */\n/* REVISED: User Codes Cards Layout */\n/* ========================= */\n.user-codes-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 25px;\n    margin: 25px;\n}\n\n.manage-code-card {\n    background: var(--background-color-light);\n    color: var(--text-color-dark);\n    padding: 25px;\n    border-radius: 12px;\n    box-shadow:\n        0 4px 15px var(--shadow-color),\n        0 8px 25px var(--shadow-color);\n    cursor: pointer;\n    min-height: 120px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    word-wrap: break-word;\n    overflow: hidden;\n    transition: transform 0.2s, box-shadow 0.2s, border 0.2s;\n    border: 1px solid #f0f0f0;\n    background-color: white;\n}\n\n.manage-code-card:hover {\n    transform: translateY(-5px) scale(1.02);\n    box-shadow:\n        0 6px 20px rgba(0, 0, 0, 0.1),\n        0 12px 30px rgba(0, 0, 0, 0.15);\n}\n\n/* NEW: This class will align the product name and status badge side-by-side. */\n.product-header {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px; /* Adjust the spacing between the name and status */\n    margin: 5px;\n}\n\n.manage-code-card h3 {\n    color: var(--primary-color);\n    margin-top: 0;\n    margin-bottom: 5px;\n    font-size: 1.25em;\n    font-weight: 700;\n    word-break: break-all;\n}\n\n.manage-code-card p {\n    color: #666;\n    font-size: 1em;\n    font-weight: 400;\n    margin: 5px 0;\n    word-break: break-all;\n}\n\n.test {\n    font-weight: 500;\n    margin: 5px 0px;\n}\n\n/* REVISED: Styles for the status badge */\n.manage-code-card .status {\n    padding: 0.3rem 0.8rem;\n    border-radius: 20px;\n    font-size: 0.85rem;\n    font-weight: 600;\n    text-transform: capitalize;\n    color: var(--text-color-light);\n    margin: 0;\n}\n\n.manage-code-card .status.used {\n    background-color: var(--success-color);\n    box-shadow: 0 0 8px #28a745; \n}\n\n.manage-code-card .status.unused {\n    background-color: var(--pending-color);\n    box-shadow: 0 0 8px #f0ad4e; \n}\n\n/* 🌟 NEW ADDITION FOR EXPIRED STATUS 🌟 */\n.manage-code-card .status.expired {\n    /* Uses the locally defined --danger-color */\n    background-color: var(--danger-color); \n    box-shadow: 0 0 8px #dc3545; \n}\n/* ------------------------------------- */\n\n\n@media (max-width: 768px) {\n    .search-form {\n        margin: 2% 10% 7% 10%;\n        display: flex;\n        gap: 10px;\n    }\n    \n    .manage-code-card .status {\n        padding: 2px 6px;\n        margin: 0;\n        font-size: 13px;\n    }\n\n    .manage-order-container {\n        margin:0;\n        padding: 0;\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    }\n\n    .manage-code-card p {\n        font-size: 15px;\n    }\n\n    .manage-code-card h3 {\n        font-size: 17px;\n    }\n\n    .manage-code-card {\n        padding: 10px;\n        min-height: 100px;\n    }\n\n    .user-codes-grid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 20px;\n        margin: 1%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
